import { SpotlightDocumentSchema } from "@redotech/redo-model/spotlight-document-schema";
import { SpotlightFormSchema } from "@redotech/redo-model/spotlight-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateSpotlight = {
  name: "updateSpotlight" as const,
  input: z.object({
    spotlightId: zExt.objectId(),
    form: SpotlightFormSchema,
    enabled: z.boolean().optional(),
  }),
  output: z.object({ spotlight: SpotlightDocumentSchema.nullable() }),
};
